export default "__VITE_ASSET__twzSvA9O__"